/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Scheduled/view.blocks to change it.
import React from 'react'
import Tysiav2CalendarScheduledIcon from 'DesignSystem/Svgs/Tysiav2CalendarScheduledIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Scheduled({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/StateIcon/Scheduled",
  fill2
  
}) {
  return (<React.Fragment
>
<Tysiav2CalendarScheduledIcon
  viewPath={`${viewPath}/Tysiav2CalendarScheduledIcon`}
 fill2={fill2}
/>
{children}
</React.Fragment>)
}